/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey
 */

import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
  /**
   *  Warren Dowey
   *
   *  intercept
   *
   *  Prefixes all requests with `environment.serverUrl`.
   *
   * @params request: HttpRequest<any> next: HttpHandler
   * @params next: HttpHandler
   *
   * @returns void: A httpevent as an observable that prefixes all http requests.
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = <string>request.url;
    if (!/^(http|https):/i.test(url) && url !== 'assets/text/report-styles.txt') {
      request = request.clone({ url: environment.secureServerUrl + request.url });
    }
    return next.handle(request);
  }
}
